import { computed } from 'vue';

import { INSTANCE_AI_MCP_CONNECTIONS_EXPERIMENT } from '@/app/constants/experiments';
import { usePostHog } from '@/app/stores/posthog.store';

export function useInstanceAiMcpConnectionsExperiment() {
	const posthogStore = usePostHog();

	const isFeatureEnabled = computed(
		() =>
			posthogStore.getVariant(INSTANCE_AI_MCP_CONNECTIONS_EXPERIMENT.name) ===
			INSTANCE_AI_MCP_CONNECTIONS_EXPERIMENT.variant,
	);

	return { isFeatureEnabled };
}
